import React from 'react';
import styled from 'styled-components';

const StyledSpan = styled.span`
  float: left;
  width: 93%;
  text-align: left;
  margin-right: 12px;
`;

interface Props {
  children: any;
  className?: string;
}

export const MessageSpan = (props: Props) => {
  const { children, className } = props;
  return <StyledSpan className={className}>{children}</StyledSpan>;
};
